import React from "react";
import { Typography } from "src/latest/src/components";

const WhyInfoModal: React.FC = () => {
    return (
        <div className="client_checkIn_modal__content">
            <Typography variant="size-16" color="color-2">
                This information helps you and your therapist to track your progress in therapy. Research shows that therapy is more beneficial when a therapist is able to accurately track their client's progress. While it may be tempting to "inflate" your responses to make your therapist feel good, research also shows that therapy is more beneficial when clients are able to provide their therapists with honest feedback about the process.
            </Typography>
            <Typography
                variant="size-16"
                color="color-2"
                className="d-inline-block client_checkIn_modal__content-first"
            >
                Please note that the information that you provide during this check in may or may not be reviewed by your therapist and is <span>not a substitute for direct communication</span> with your therapist. If you are experiencing a psychological crisis you <Typography weight="bold" className="d-inline-block">MUST</Typography> communicate this directly to your therapist during your therapy session.
            </Typography>
            <div className="client_checkIn_modal__content-footer">
                <Typography
                    variant="size-14"
                    color="color-28"
                    className="text-center"
                >
                    If you are experiencing an emergency or psychological crisis you should call 911. For additional resources please refer to: <a href="https://www.mentalhealth.gov/get-help/immediate-help" rel="noreferrer" target="_blank">https://www.mentalhealth.gov/get-help/immediate-help</a>
                </Typography>
            </div>
        </div>
    );
};

export default WhyInfoModal;